import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { resources } from "./resources.js";
import { IS_FRANCE_MARKET } from "../utils/market.js";

const STORAGE_KEY = "language";
const DEFAULT_LANGUAGE = "hy";
// On fr.greenwich.am a first-time visitor has never picked a language — default
// them to French instead of Armenian. Anyone who already chose a language
// (stored in localStorage) keeps that choice regardless of domain.
const MARKET_DEFAULT_LANGUAGE = IS_FRANCE_MARKET ? "fr" : DEFAULT_LANGUAGE;

export function getInitialLanguage() {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored && stored in resources) return stored;
  return MARKET_DEFAULT_LANGUAGE;
}

export function setLanguage(lang) {
  if (!(lang in resources)) return;
  localStorage.setItem(STORAGE_KEY, lang);
  i18n.changeLanguage(lang);
  document.documentElement.lang = lang;
}

if (!i18n.isInitialized) {
  const initialLng = getInitialLanguage();

  i18n.use(initReactI18next).init({
    resources,
    lng: initialLng,
    // Always English, never MARKET_DEFAULT_LANGUAGE: fr/de/es/pt only cover a
    // fraction of the keys en/hy/ru do, so falling back to the SAME sparse
    // language (fr -> fr) left missing keys with nowhere to fall to, showing
    // the raw key string instead of any text at all.
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });

  document.documentElement.lang = initialLng;
}

export default i18n;

